import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './account-card.scss';
import Button from '../button/button';
import { useNavigate } from 'react-router-dom';
import BookMark from '@assets/icons/bookmark.svg';
import DataLayerService from '../../../services/data-layer-service';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ModalAttentionSchedule } from '..';
import { ModalMaintenance } from '..';
import { useIsAttentionSchedule, useIsMaintenanceMode } from '../../../utils/utils';
const AccountCard = (props) => {
    const isAvailable = useIsAttentionSchedule();
    const maintenanceMode = useIsMaintenanceMode();
    const [imageLoaded, setImageLoaded] = useState(false);
    const [modalAttentionScheduleOpen, setModalAttentionScheduleOpen] = useState(false);
    const [modalMaintenanceOpen, setModalMaintenanceOpen] = useState(false);
    const history = useNavigate();
    const { productId, title, percentageNumber, percentageLabel, infoList, mainUrl, titleCoin, image, highlight, terms, handleOpenModal, badge, icon, desktopbanner, altImage } = props;
    const isMobile = useMediaQuery('(max-width: 600px)');
    const goToRegister = (path) => {
        if (!isAvailable) {
            DataLayerService.sendEvent('cadenacierre', {
                Seccion: 'ERROR',
                SubSeccion: '',
                SubZona: title + " - " + titleCoin,
                TipoElemento: 'Error',
                TipoEvento: 'Click',
                TipoZona: 'Onboarding Digital',
                Valor: '',
                Zona: 'Inicio'
            });
            setModalAttentionScheduleOpen(true);
            return;
        }
        console.log("maintenanceMode", maintenanceMode);
        if (maintenanceMode === "1") {
            console.log("entra en mantenimiento");
            DataLayerService.sendEvent('mantenimiento', {
                Seccion: 'ERROR',
                SubSeccion: '',
                SubZona: title + " - " + titleCoin,
                TipoElemento: 'Error',
                TipoEvento: 'Click',
                TipoZona: 'Onboarding Digital',
                Valor: '',
                Zona: 'Inicio'
            });
            setModalMaintenanceOpen(true);
            return;
        }
        let eventName = title.toLowerCase().includes('full') ? 'FA' : title.toLowerCase().includes('gana') ? 'AG' : 'AN';
        eventName += '_Abrir';
        DataLayerService.sendEvent(eventName, {
            Seccion: '',
            SubSeccion: '',
            SubZona: title + " - " + titleCoin,
            TipoElemento: 'Boton',
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: 'Abrir cuenta',
            Zona: 'Inicio'
        });
        console.log("path", path);
        console.log("productId", productId);
        console.log("accountType", props.title);
        history(path, { state: { productId, accountType: props.title } });
    };
    const handleSaberMas = () => {
        let eventName = title.toLowerCase().includes('full') ? 'FA' : title.toLowerCase().includes('gana') ? 'AG' : title.toLowerCase().includes('negocios') ? 'AN' : 'ST';
        eventName += '_Saber';
        DataLayerService.sendEvent(eventName, {
            Seccion: '',
            SubSeccion: '',
            SubZona: title + " - " + titleCoin,
            TipoElemento: 'Link',
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: 'Ver más',
            Zona: 'Inicio'
        });
        if (handleOpenModal)
            handleOpenModal(title, props);
    };
    const handleCloseAttentionScheduleModal = () => {
        DataLayerService.sendEvent('cadenacierre_entiendo', {
            Seccion: 'ERROR',
            SubSeccion: '',
            SubZona: title + " - " + titleCoin,
            TipoElemento: 'Boton',
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: 'Entiendo',
            Zona: 'Inicio'
        });
        setModalAttentionScheduleOpen(false);
    };
    const handleCloseMaintenanceModal = () => {
        DataLayerService.sendEvent('manteniemiento_entiendo', {
            Seccion: 'ERROR',
            SubSeccion: '',
            SubZona: title + " - " + titleCoin,
            TipoElemento: 'Boton',
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: 'Entiendo',
            Zona: 'Inicio'
        });
        setModalMaintenanceOpen(false);
    };
    useEffect(() => {
        const imageToLoad = new Image();
        imageToLoad.onload = () => {
            setImageLoaded(true);
        };
        imageToLoad.src = image;
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: `account-card-new`, children: [badge && (_jsxs("div", { className: "account-card-new__badge", children: [_jsx("img", { src: BookMark, alt: "Nueva", className: "account-card-new__badge-icon" }), badge] })), !isMobile && _jsx("div", { className: "account-card-new__card-image", children: _jsx("img", { src: desktopbanner, alt: altImage, className: "account-card-new__card-banner-imagen" }) }), _jsxs("div", { className: "account-card-new__header", children: [_jsxs("div", { children: [_jsxs("div", { className: "account-card-new__icon-title", children: [_jsx("img", { src: icon, alt: "icono", className: "account-card-new__icon" }), _jsx("div", { className: "account-card-new__label", children: "Cuenta" })] }), _jsx("div", { className: "account-card-new__title", children: _jsx("h2", { children: title }) })] }), percentageNumber && (_jsxs("div", { className: "account-card-new__percentage-box", children: [_jsxs("div", { className: "account-card-new__percentage", children: [percentageNumber, _jsx("span", { className: "account-card-new__percentage__symbol" })] }), _jsx("div", { className: "account-card-new__percentage-label", children: percentageLabel })] }))] }), _jsx("div", { className: "account-card-new__description", children: infoList[0] }), infoList[1] && (_jsxs("div", { className: "account-card-new__subbox", children: [_jsx("div", { className: "account-card-new__subbox-title", dangerouslySetInnerHTML: { __html: infoList[1].split('<br>')[0] } }), infoList[2] && (_jsx("div", { className: "account-card-new__subbox-sub", children: infoList[2] }))] })), _jsxs("div", { className: "account-card-new__buttons", children: [_jsx("div", { className: "account-card-new__buttons__main-link", onClick: handleSaberMas, children: _jsx("span", { className: "account-card-new__buttons__text", children: "Ver más" }) }), _jsx(Button, { className: 'account-card-new__buttons__button', label: "Abrir cuenta", action: () => goToRegister(mainUrl), isAnimated: true })] })] }), _jsx(ModalAttentionSchedule, { openModal: modalAttentionScheduleOpen, closeModal: handleCloseAttentionScheduleModal }), !modalAttentionScheduleOpen && _jsx(ModalMaintenance, { openModal: modalMaintenanceOpen, closeModal: handleCloseMaintenanceModal })] }));
};
export default AccountCard;
